export { default } from './ViewCompositionLyrics';
